module.exports = __webpack_public_path__ + "img/30m4.7eae7173.jpg";